module.exports = __webpack_public_path__ + "static/main-250-dc572b2009f670437adb566ab34d3045.png";